import { createContext, useContext, ReactNode, useMemo } from 'react';
import { getOrSetUniqueIdentifier } from '@mono-farmart-web/utilities/utils';

interface IUserContext {
	userId: string;
}
const UserContext = createContext<IUserContext | null>(null);

export const useUserContext = (): IUserContext => {
	const context = useContext(UserContext);
	if (!context) {
		throw new Error('useUserContext must be used within an ApiProvider');
	}
	return context;
};

interface UserProviderProps {
	globalUserId?: string;
	children: ReactNode;
}

export const UserProvider = ({ children, globalUserId }: UserProviderProps) => {
	const userId = useMemo(
		() => globalUserId || getOrSetUniqueIdentifier('fmt-ai-user-id', 'local'),
		[globalUserId],
	);
	return (
		<UserContext.Provider value={{ userId }}>{children}</UserContext.Provider>
	);
};
